query moods($teamId: ID) {
  moods(teamId: $teamId) {
    id
    name
    displayOrder
  }
}
